module.exports = __webpack_public_path__ + "img/logo_slim_inverted.ed2006b7.svg";